import { Directive, ElementRef, Renderer2, OnInit, input, effect, inject } from '@angular/core';

export type HeadingLevel = 'h1' | 'h2' | 'h3' | 'h4';

@Directive({
  selector: '[cmHeading]',
  standalone: true,
})
export class HeadingDirective implements OnInit {
  public readonly level = input<HeadingLevel>('h1');

  private readonly _elementRef = inject(ElementRef);
  private readonly _renderer = inject(Renderer2);

  private readonly _headingStyles: Record<HeadingLevel, string[]> = {
    h1: ['text-18', 'font-weight-700', 'text-gray-1', 'mod-margin-none'],
    h2: ['text-16', 'font-weight-700', 'text-gray-1', 'mod-margin-none'],
    h3: ['text-14', 'font-weight-700', 'text-gray-1', 'mod-margin-none'],
    h4: ['text-12', 'font-weight-700', 'text-gray-1', 'mod-margin-none'],
  };

  private _currentClasses: string[] = [];

  constructor() {
    effect(() => {
      this._applyStyles(this.level());
    });
  }

  public ngOnInit(): void {
    this._applyStyles(this.level());
  }

  private _applyStyles(level: HeadingLevel): void {
    const element = this._elementRef.nativeElement;

    this._currentClasses.forEach((className) => {
      this._renderer.removeClass(element, className);
    });

    const classes = this._headingStyles[level] || this._headingStyles.h1;
    classes.forEach((className) => {
      this._renderer.addClass(element, className);
    });

    this._currentClasses = [...classes];
  }
}
